import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'

export interface IGenerateBlogSummary extends IAction<string, GenerateBlogSummaryArgs> {}

@InputType()
export class GenerateBlogSummaryArgs extends ActionArgs {
  @Field(() => ID)
  blogId: string
}
